<ng-container *ngIf="targetType && targetId">
    <form id="noteForm"
          [formGroup]="form"
          novalidate
          #f>
        <mat-form-field class="col__ compact ongray"
                        [ngSwitch]="note.noteType">

            <!-- Input is a date value -->
            <!-- <input *ngSwitchCase="'date'"
                   type="date"
                   matInput
                   formControlName="text" /> -->

            <ng-container *ngSwitchCase="'date'">
                <input matInput
                       type="text"
                       [matDatepicker]="datePicker"
                       placeholder="MM/DD/YYYY"
                       autocomplete="off"
                       formControlName="text"
                       name="date">
                <mat-datepicker-toggle matSuffix
                                       [for]="datePicker">
                    <mat-icon fontSet="far"
                              fontIcon="fa-calendar"
                              matDatepickerToggleIcon></mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #datePicker></mat-datepicker>
                <app-input-error [formControlItem]="noteControl"></app-input-error>
            </ng-container>

            <!-- Input is a number value-->
            <input *ngSwitchCase="'number'"
                   type="text"
                   matInput
                   formControlName="text"
                   decimalMask />

            <!-- Input is a text value-->
            <textarea *ngSwitchDefault
                      matInput
                      matTextareaAutosize
                      matAutosizeMinRows="2"
                      matAutosizeMaxRows="5"
                      placeholder="Make a note."
                      formControlName="text"
                      data-test-id="noteInput"></textarea>
        </mat-form-field>
        <div class="flex flexAlign--center flexJustify--end mt-0050">
            <span class="link link--small link--noline spacerRight"
                  (click)="onCancel()"
                  data-test-id="cancelSaveNoteBtn">Cancel</span>
            <button type="button"
                    class="btn btn--white btn--sm spacerLeft--lg"
                    (click)="onSave(f)"
                    data-test-id="saveNoteBtn">Save</button>
        </div>
    </form>
</ng-container>
